module.exports = ConfigVariables;